// extracted by mini-css-extract-plugin
var _1 = "back-aacrS";
var _2 = "border-HS0P3";
var _3 = "img-MF4Gq";
var _4 = "modal-MCFRd";
var _5 = "wrap-Oax6W";
export { _1 as "back", _2 as "border", _3 as "img", _4 as "modal", _5 as "wrap" }
